import InvalidAccessImage from "@assets/images/invalid_access.svg";
import { IoReload } from "react-icons/io5";
import { useSearchParams } from "react-router-dom";

const InvalidAccessPage = () => {
  const [URLSearchParams, _setParams] = useSearchParams();

  return (
    <div className="w-full h-[80vh] rounded-md  flex justify-center flex-col items-center  backdrop-blur-md bg-white gap-7">
      <div className="w-[400px] h-[300px]">
        <img src={InvalidAccessImage} alt="" />
      </div>
      <div className="py-10 flex items-center justify-center flex-col">
        <p className="text-sm font-semibold">Oops! Page cannot be accessed</p>
        <p className="text-gray-600">Either you don't have permission or required data hasn't been loaded yet.</p>
        <button className="mt-4 mb-4 bg-[#193A6A] p-2 border-transparent text-white rounded-lg px-4 text-sm font-semibold">
          <a href={URLSearchParams.get("redirect_uri")}>
            <span className="flex justify-start items-center gap-x-2">
              {" "}
              <span>
                <IoReload className="w-4 h-4" />
              </span>{" "}
              <span>Retry</span>
            </span>
          </a>
        </button>
      </div>
    </div>
  );
};

export default InvalidAccessPage;
